export default __webpack_public_path__ + "static/media/smultron_logo.8cd900ce.png";